import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

import { SidebarElement } from '@/components/MainSidebar/styles'
import { SidebarProps } from '@/types/componentsPropsTypes'

export const SettingsSidebarElement = styled(SidebarElement)<SidebarProps>`
  width: 384px;
  background: ${({ theme }) => theme.colors.sidebar.sidebarBackground.start};
`

export const SettingsMenu = styled(FocusNode)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  min-width: 100%;
`
export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`
export const ItemListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  min-height: 650px;
  margin-bottom: 10px;
`

export const MenuItemWrapper = styled.div<{
  $hasDivider: boolean
}>`
  flex: ${({ $hasDivider }) => ($hasDivider ? '1 1' : '0 0 76px')};
  background: transparent;
`

export const MenuTitle = styled.div`
  padding-left: 18px;
  margin-bottom: 36px;
  font-weight: 700;
  font-size: 26px;
  line-height: 24px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.sidebar.text};
  opacity: 0.9;
`

export const MenuButtonBack = styled.div`
  margin: 12px 0 16px 12px;
  & > button {
    border-radius: 8px;
  }
`

export const AppVersion = styled.span`
  font-size: 20px;
  line-height: 1;
  opacity: 0.25;
  text-align: center;
  height: 50px;
`
